<script>
    import { getContext } from 'svelte'

    const { isOpen, toggleOpen } = getContext('menu')
</script>

<div class={`mobile-menu-button ${$isOpen ? 'open' : ''}`} on:click={toggleOpen}>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
</div>

<style lang="scss">
    .mobile-menu-button {
        box-shadow: none;
        position: absolute;
        top: 15px;
        right: 0;
        font-size: 0;
        padding: 0;
        bottom: 0;
        border: none;
        background: 0 0;
        width: 28px;
        height: 40px;
        cursor: pointer;

        span {
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            height: 2px;
            background-color: #343B45;
            transition: all .15s ease-in-out,background-color .2s ease-in-out;

            &:nth-child(1) {
                top: 17px;
            }

            &:nth-child(2),
            &:nth-child(3) {
                top: 25px;
            }

            &:nth-child(4) {
                top: 33px;
            }
        }

        &.open {
            span {
                &:nth-child(1) {
                    left: 50%;
                    width: 0;
                    top: 21px;
                }

                &:nth-child(2) {
                    transform: rotate(45deg);
                }

                &:nth-child(3) {
                    transform: rotate(-45deg);
                }

                &:nth-child(4) {
                    left: 50%;
                    width: 0;
                    top: 21px;
                }
            }
        }
    }
</style>